import React from 'react'
import { localized } from '@/decorators/localized'
import { MinimumLengthSearchList } from '@/internal-app/components/minimumLengthSearchList'
import { BsrsGrid, EnumFilterCell, EnumCell, NameColumn, actionButtonsColumnProps, DateCell, DateFilterCell } from '@/components/BsrsGrid'
import { GridColumn as Column } from '@progress/kendo-react-grid'
import context from '@/context'
import { personTypes } from '@/enums/PersonTypes'

@localized()
class BlackList extends MinimumLengthSearchList {
  getTitle () { return 'Blacklists.BlacklistTitle' }
  getScope () { return 'Blacklists' }
  getCreateNewButtonText () { return 'Blacklists.CreateNew' }

  renderGrid () {
    const { localize, locale } = this.props
    const enumName = personTypes.enumName
    return (
      <BsrsGrid
        persistenceId={'blacklists'}
        dataSource={(request, options) => context.api.blacklistRecordService.getTableData(this.state.searchExpression, request, options)}
        filterable
        lastReloadedAt={this.state.lastReloadedAt}>
        <Column field='personName' title={localize('Blacklists.PersonName')} editable={false} />
        <Column field='personLatinName' title={localize('Blacklists.PersonLatinName')} editable={false} />
        {NameColumn({ locale, nameProp: 'blacklistName', latinNameProp: 'blacklistLatinName', title: localize('Blacklists.Type'), editable: false })}
        <Column field='personType' title={localize('Blacklists.PersonType')} editable={false}
          cell={EnumCell({ localize, enumName })}
          filterCell={EnumFilterCell({ localize, enumName }, personTypes.values.filter(x => x !== personTypes.enum.Unknown))} enumName={enumName} />

        <Column field='validFrom' title={localize('Common.ValidFrom')} filter='date' cell={DateCell} filterCell={DateFilterCell} editable={false} />
        <Column field='validTo' title={localize('Common.ValidTo')} filter='date' cell={DateCell} filterCell={DateFilterCell} editable={false} />
        <Column {...actionButtonsColumnProps([{ url: x => `/blacklists/${x.id}`, icon: 'pencil' }])} />
      </BsrsGrid>
    )
  }
}

export default BlackList



// WEBPACK FOOTER //
// ./src/internal-app/pages/blackLists/list.js